import React, {useEffect,useState} from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import {Button,Typography,Grid} from '@mui/material/';

import { DataGrid, GridToolbar,frFR  } from '@mui/x-data-grid';
import DialogTitle from '@mui/material/DialogTitle';
import Autorize from '../../components/ui/autorize';
import Cookies from 'js-cookie'

import { getSessionValide ,getUserRule,getSessionExpirer } from '../../utils/userRule';
//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering


export default function FacturationClub({clubid,secteur,ruleWrite,solde}) {
    
        
   
   // const [autorize, setAutorize] = useState("false");
    const [errorAxios, setErrorAxios] = useState(true);
    const [ordersList, setOrdersList] = useState([]);
    const [factureAssignationOrdersList, setFactureAssignationOrdersList] = useState("");

    
  /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
const MyAxios = axios.create({    
    headers: { Authorization: "Bearer "+ Cookies.get('token'),
            }      
})


    useEffect(() => {

      
        const fetchData = async () => {
            try {

                let RuleRead_Club = await getUserRule("read_club",sessionStorage.getItem('clubId'),sessionStorage.getItem('secteur'));
                setErrorAxios(false);
                if(RuleRead_Club === true)
                    LoadData();

                   
            } catch (error) {
                setErrorAxios(true);
                console.error('Une erreur s\'est produite lors de la récupération des données', error);
            }
        };  
        fetchData(); // Appel de la fonction asynchrone
          


         // LoadData();

    },[clubid]);



    function LoadData()
    {
        //console.log(process.env.REACT_APP_API + '/members/get/secteur/'+ secteur +'/club/'+ clubid+ '/actifonly/false');
        MyAxios.get(process.env.REACT_APP_API + '/woo/listOrders/'+ clubid )
        .then((res) => {                
            setOrdersList(res.data);   
        })
        .catch((error) => {
            console.log("error axios",error);  
            setErrorAxios(true);
        });


        MyAxios.get(process.env.REACT_APP_API + '/officers/getDefaultAssignationOrder/'+ clubid )
        .then((res2) => {  
                      
           // console.log("-------------------facturation-----------------------------");   
            //console.log(res2.data[0]);
            setFactureAssignationOrdersList(res2.data[0]['first_name'] + " " + res2.data[0]['last_name']); 
           // console.log("------------------------------------------------");  
        })
        .catch((error) => {
            console.log("error axios",error);  
           // setErrorAxios(true);
        });

    }

    function getFacture(row)
    {
        //console.log(process.env.REACT_APP_API + '/members/get/secteur/'+ secteur +'/club/'+ clubid+ '/actifonly/false');
               
        MyAxios({
            url: process.env.REACT_APP_API + '/storage/getFacture/'+ row.orderId.substring(4,row.orderId.length),
            method: 'GET',
            responseType: 'blob', // important
        }).then((res) => {         
            
            const href = URL.createObjectURL(res.data);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'Facture-'+ row.orderId +'.pdf'); //or any other extension
            document.body.appendChild(link);
            link.click();
            // setOrdersList(res.data);   
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        })
        .catch((error) => {
            setErrorAxios(true);
        });

    } 


  

    const columns = [      
            {      field: 'orderId',            headerName: 'Facture #' ,        width: 100 ,    }  ,     
            {      field: 'noClub',     headerName: 'Numéro club' ,    width: 100 ,   }  , 
            {
                field: "action",
                headerName: "Voir la facture",
                sortable: false,
                width:225,
                renderCell: ({ row }) =>
                  <Button onClick={() => getFacture(row)}>
                    Voir la facture PDF
                  </Button>,
              },     

            {      field: 'invoice_date_timestamp',     headerName: 'Date facturation' ,  width: 175 ,     }  ,
            {      field: 'status',      headerName: 'Statut' ,    width: 100 ,    }  , 
            {      field: 'name',        headerName: 'Produit' ,    width: 230 ,      }  ,
            {      field: 'quantity',        headerName: 'Quantité' ,   width: 80 ,       }  ,
            {      field: 'price',        headerName: 'Prix' ,   width: 100 ,       }  ,             
            {      field: 'total',        headerName: 'Total' ,   width: 100 ,       }  ,     
        ];


        
 return (
        <div>
            <Autorize axiosError={errorAxios} />
            {getMain()}
        </div>
    );  

    /* <Typography  variant="h6" sx={{ fontSize: 17 }} color="text.primary" gutterBottom>
                        {factureAssignationOrdersList != undefined ?  {factureAssignationOrdersList}  : "Les facture ne s'assigneront pa personne."  } 
                    </Typography> */

function getMain()
{

   
//| Envoyé à : {factureAssignationOrdersList}
        return (
            <div >              
                    <Typography  variant="h6" sx={{ fontSize: 17 }} color="text.primary" gutterBottom>
                        Solde à payer par le club:  {solde != null ?  <Typography  variant='h6' sx={{ fontSize: 17 }} color='red' >Le solde est de {solde} $  </Typography> :  <>Aucun solde </>  } 
                    </Typography>           
                   
                        <div style={{ height: 600 }}>
                            <DataGrid key="DataGridMember" localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                                rows={ordersList}
                                columns={columns}             
                                components={{ Toolbar: GridToolbar }}                                                                 
                            />

                        </div>    
                        <Grid
                            container                           
                            direction="row"
                            alignItems="right"
                            justifyContent="right"
                           
                            >
                                  
                                <Grid item sx={11}  p={1}  >

                                <Typography  variant="h6" sx={{ fontSize: 17 }} color="text.primary" gutterBottom>
                                         Solde à payer par le club:  {solde != null ?  <Typography  variant='h6' sx={{ fontSize: 17 }} color='red' >Le solde est de {solde} $   </Typography> : "Aucun solde"  } 
                                </Typography>                                                        
                                        
                                </Grid>
                        </Grid>
        </div>
       

        );
    
}

}
